import Vue  from "vue";

const store = Vue.observable({
    items: [],
});

function updateContacts(list = []) {
    store.items = [].concat(list);
}

function removeContact(uid) {
    store.items = store.items.filter((row) => {
        return row.uid == uid;
    })
}

function addContact(row) {
    let index = store.items.findIndex((item) => {
        return item.uid == row.uid
    })
    if (index > -1) {
        Vue.set(store.items, index, {
            ...row,
        });
    } else {
        store.items.unshift(row);
    }
}

function waitForContactsFilled(timeout = 1500) {
    let intervalID = 0;
    return Promise.race([new Promise((resolve) => {
        const handler = () => {
            if (store.items.length > 0) {
                clearInterval(intervalID)
                resolve();
            }
        }
        intervalID = setInterval(handler, 500);
        handler();
    }), new Promise((resolve) => {
        setTimeout(() => {
            clearInterval(intervalID)
            resolve();
        }, timeout);
    })]);
}

function contactRead(uid) {
    return waitForContactsFilled().then(() => {
        const index = store.items.findIndex((item) => {
            return item.uid == uid
        })
        if (index > -1) {
            Vue.set(store.items[index], "unread", 0);
        }
    });
}

function contactUnread(uid) {
    return waitForContactsFilled().then(() => {
        const index = store.items.findIndex((item) => {
            return item.uid == uid
        })
        if (index > -1) {
            Vue.set(store.items[index], "unread", 1);
        }
    })
}


export default store;
export {
    updateContacts,
    removeContact,
    addContact,
    contactRead,
    contactUnread,
}
